export class FailedInvoiceViewModel {
    InvoiceNumber: string;
    PatientCode: string;
    PatientName: string;
    PayerId: number;
    PayerTitle: string;
    RowCount: number;
}
